export default __webpack_public_path__ + "static/media/Selected_1.01e9f32b.svg";